export default __webpack_public_path__ + "static/media/UNAMID_humanitarian_coordination.f79fdb51.jpg";